import { Card, CardContent } from "@/components/ui/card";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { Badge } from "@/components/ui/badge";

const trails = [
  { id: 1, user: "admin@loanpro.com", action: "Approved Loan LN004", date: "2026-02-17 10:30", ip: "192.168.1.1" },
  { id: 2, user: "manager@loanpro.com", action: "Disbursed Loan LN003", date: "2026-02-17 09:15", ip: "192.168.1.2" },
  { id: 3, user: "admin@loanpro.com", action: "Created User 'Field Agent'", date: "2026-02-16 16:00", ip: "192.168.1.1" },
  { id: 4, user: "officer@loanpro.com", action: "Updated Customer Profile #100234", date: "2026-02-16 14:30", ip: "192.168.1.3" },
  { id: 5, user: "admin@loanpro.com", action: "Changed Settings", date: "2026-02-16 11:00", ip: "192.168.1.1" },
];

export default function AuditTrailsPage() {
  return (
    <div className="space-y-6">
      <h1 className="text-2xl font-bold">Audit Trails</h1>
      <Card className="shadow-card">
        <CardContent className="p-0">
          <Table>
            <TableHeader>
              <TableRow>
                <TableHead>User</TableHead>
                <TableHead>Action</TableHead>
                <TableHead>Date</TableHead>
                <TableHead>IP Address</TableHead>
              </TableRow>
            </TableHeader>
            <TableBody>
              {trails.map((t) => (
                <TableRow key={t.id}>
                  <TableCell className="font-medium">{t.user}</TableCell>
                  <TableCell>{t.action}</TableCell>
                  <TableCell className="text-muted-foreground">{t.date}</TableCell>
                  <TableCell>
                    <Badge variant="secondary">{t.ip}</Badge>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </CardContent>
      </Card>
    </div>
  );
}
